import { useMutation, useQueryClient } from "@tanstack/react-query"
import { profile } from "@shared/api/services"
import { toast } from "react-toastify"

export const useUpdateProfile = () => {
	const queryClient = useQueryClient()

	const mutation = useMutation({
		mutationFn: (data) => profile.updateProfile(data),
		onError: err => console.log(err),
    onSuccess: () => {
      queryClient.invalidateQueries(['profile'])
			toast.success('Данные обновлены')
    },
  })

	return mutation
}